"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.moveAndRepriceTransferLine = void 0;
const _ = require("lodash");
const helpers_1 = require("../../helpers");
const tryFindTransferRates_1 = require("./tryFindTransferRates");
const dayjs = require("dayjs");
const sortAndGroupTransferRates_1 = require("./sortAndGroupTransferRates");
const moveAndRepriceTransferLine = async (order_line_version, new_date, margin_discount_percentage = 0, default_historic_price_increase = 5, supabase) => {
    const new_version = _.cloneDeep(order_line_version);
    new_version.start_date = new_date;
    new_version.end_date = new_date;
    const transfer_rates = await (0, tryFindTransferRates_1.tryFindTransferRates)(supabase, null, {
        id: new_version.config?.transfer_legs?.outbound?.from_area,
        name: new_version.config?.transfer_legs?.outbound?.from_name,
        type: new_version.config?.transfer_legs?.outbound?.from_type,
        address: new_version.config?.transfer_legs?.outbound?.from_name,
    }, {
        id: new_version.config?.transfer_legs?.outbound?.to_area,
        name: new_version.config?.transfer_legs?.outbound?.to_name,
        type: new_version.config?.transfer_legs?.outbound?.to_type,
        address: new_version.config?.transfer_legs?.outbound?.to_name,
    }, null, new_version.config?.where_when_who?.type, new_date);
    const sorted_rates = (0, sortAndGroupTransferRates_1.sortAndGroupTransferRates)(transfer_rates, new_version.config?.where_when_who?.type, new_version.config?.where_when_who?.number_of_passengers, false);
    const config = new_version.config;
    // this means we cannot find any rates.  in this instance we need to 'clear' the line so that you have to manually reselect the transfer in the modal
    // get the cheapest rate by rate_total_price
    const transfer_rate = _.minBy(sorted_rates.rates, "rate_total_price");
    if (!transfer_rates)
        return new_version;
    //  if no rates found then clear the line
    if (!sorted_rates || sorted_rates?.rates?.length === 0) {
        config.vehicle = helpers_1.TRANSFER_LINE_INITIAL_STATE.vehicle;
    }
    else {
        config.where_when_who.date = new_date;
        let margin = transfer_rate.rate_margin;
        let historic_price_increase = 1;
        if (transfer_rates?.historical) {
            if (transfer_rates.offset === 1) {
                historic_price_increase = default_historic_price_increase / 100 + 1;
            }
            if (transfer_rates.offset === 2) {
                historic_price_increase =
                    (default_historic_price_increase / 100) * transfer_rates.offset + 1;
            }
            // apply the margin percentage discount
            if (margin_discount_percentage) {
                const percentage = (100 - margin_discount_percentage) / 100;
                margin = margin * percentage;
            }
        }
        const rate_config = {
            historic_rate: transfer_rates.historical
                ? {
                    ...transfer_rate,
                    percentage_increase: default_historic_price_increase * transfer_rates.offset,
                    date: dayjs(new_date).subtract(1, "year").format("YYYY-MM-DD"),
                }
                : null,
            max_pax: transfer_rate.rate_max_pax,
            rate: {
                ...transfer_rate?.rates,
                type: transfer_rates.historical ? "CUSTOM" : transfer_rate?.rates?.type,
                estimated: transfer_rates.historical ? true : false,
            },
            custom: transfer_rates.historical ? true : false,
            vehicle: transfer_rate?.vehicle,
            outbound_cost: Number((transfer_rate.rate_outbound_cost_price * historic_price_increase).toFixed(0)),
            outbound_margin: Number((transfer_rate.rate_outbound_margin * historic_price_increase).toFixed(0)),
            outbound_price: Number((transfer_rate.rate_outbound_sell_price * historic_price_increase).toFixed(0)),
            outbound_total: Number((transfer_rate.rate_outbound_total_price * historic_price_increase).toFixed(0)),
            inbound_cost: Number((transfer_rate.rate_inbound_cost_price * historic_price_increase).toFixed(0)),
            inbound_margin: Number((transfer_rate.rate_inbound_margin * historic_price_increase).toFixed(0)),
            inbound_price: Number((transfer_rate.rate_inbound_sell_price * historic_price_increase).toFixed(0)),
            inbound_total: Number((transfer_rate.rate_inbound_total_price * historic_price_increase).toFixed(0)),
            cost: Number((transfer_rate.rate_cost_price * historic_price_increase).toFixed(0)),
            margin: Number((margin * historic_price_increase).toFixed(0)),
            price: Number((transfer_rate.rate_cost_price +
                margin * historic_price_increase).toFixed(0)),
            total: Number((transfer_rate.rate_total_price * historic_price_increase).toFixed(0)),
            quantity: transfer_rate.rate_number_of_vehicles,
            vat: transfer_rate.supplier?.offerings?.transfers?.offerings?.transfers
                ?.vat,
            withholding_tax: transfer_rate.supplier?.offerings?.transfers?.offerings?.transfers
                ?.withholding_tax,
        };
        config.supplier = {
            id: transfer_rate.supplier.id,
            name: transfer_rate.supplier.name,
            offerings: transfer_rate.supplier.offerings,
            currency: transfer_rate.rate_base_currency,
        };
        config.vehicle = rate_config;
        if (margin_discount_percentage) {
            config.adjustments = {
                ...config.adjustments,
                margin_discount_percentage: margin_discount_percentage,
            };
        }
        new_version.config = config;
    }
    return new_version;
};
exports.moveAndRepriceTransferLine = moveAndRepriceTransferLine;
